module.exports = __webpack_public_path__ + "media/images/vp/sample.course3-cbfdd6ae6efc1355e9033611928379a6.jpg";